import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';




import { UtilesService } from './utiles.service';
import { TipoTarea } from '../Models/TipoTarea';

@Injectable()
export class VisitaTareaService {

  constructor( private _http: Http,
    private _utiles: UtilesService) { }


    ObtenerTipoTareas(): Observable<TipoTarea[]> {

      try {

        const url = this._utiles.getURL("VisitaTarea/tipoTareaLista/");


        return this._http.get(url).map((response: Response) => {
          return <TipoTarea[]>response.json();
        });



        

      } catch (error) {

        console.log(error);
      }

    }

  }
